import { apiRequest, jsonBody } from '../shared/api/client'

export interface SetupStatus {
  required: boolean
  schemaCurrent: boolean
  enabled: boolean
}

export interface SetupInput {
  organizationName: string
  organizationSlug: string
  primaryDomain: string
  administratorLocalPart: string
  administratorDisplayName: string
  administratorPassword: string
  approverLocalPart: string
  approverDisplayName: string
  approverPassword: string
  mailboxQuotaBytes: number
  confirm: boolean
}

export interface SetupResult {
  administrator: { id: string; login: string }
  configApprover: { id: string; login: string }
  organizationId: string
  domainId: string
  mailboxId: string
}

let statusPromise: Promise<SetupStatus> | undefined

export function setupStatus(force = false): Promise<SetupStatus> {
  if (force || !statusPromise) {
    statusPromise = apiRequest<SetupStatus>('/api/v1/setup/status').catch((error) => {
      statusPromise = undefined
      throw error
    })
  }
  return statusPromise
}

export function completeSetup(input: SetupInput, token: string): Promise<SetupResult> {
  return apiRequest<SetupResult>('/api/v1/setup', {
    method: 'POST',
    headers: { 'X-Inboxia-Setup-Token': token },
    body: jsonBody(input),
  })
}
